import { inject, Injectable } from '@angular/core';
import { environmenAchievement } from '../../../environments/enviroment.achievement';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GreetingWindow } from './greeting-window/greeting-window';
import { BehaviorSubject, single, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AchievementService {
  private lists = environmenAchievement;
  eventChanpion = new BehaviorSubject(false);
  summPoints: number = 0;
  readonly dialog = inject(MatDialog);

  init(account: number = 3){
    this.summPoints = 0;
    this.eventChanpion.next(false);
    
    this.lists.hardy.isSnackBar = true;
    this.lists.hardy.value = 0;
    this.lists.hardy.class = '';
    this.lists.hardy.count = 0;
    this.lists.hardy.point = 0;

    this.lists.stable.counter = 0;
    this.lists.stable.count = 0;
    this.lists.stable.isSnackBar = true;
    this.lists.stable.value = 0;
    this.lists.stable.class = '';
    this.lists.stable.point = 0;

    this.lists.master.count = 0;
    this.lists.master.isSnackBar = true;
    this.lists.master.value = 0;
    this.lists.master.class = '';
    this.lists.master.point = 0;

    this.lists.champion.count = 0;
    this.lists.champion.isSnackBar = true;
    this.lists.champion.value = 0;
    this.lists.champion.class = '';
    this.lists.champion.account = account;
    this.lists.champion.point = 0;
  }

  public fnInitHardy(points: number): void{
    if(this.lists.hardy.isSnackBar){
      //alert(`Поздравляем, Вы получили достижение в "${this.lists.hardy.name}"`);
      this.lists.hardy.isSnackBar = false;
      this.lists.hardy.value = 100;
      this.lists.hardy.class = 'active';
    }
    this.lists.hardy.point = points;
    this.lists.hardy.count = this.lists.hardy.count + 1;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    dialogConfig.data = { name:  this.lists.hardy.name , count: this.lists.hardy.count, class: 'cl-hardy' };
    const dialogRef = this.dialog.open(GreetingWindow, dialogConfig);
  }

  public fnInitStable(maxPointer: number, points: number): void{
    if(maxPointer === 100){
      this.lists.stable.counter = this.lists.stable.counter + 1;
      this.lists.stable.point = points;
      if( this.lists.stable.counter === this.lists.stable.account ){
        if(this.lists.stable.isSnackBar){ 
          // alert(`Поздравляем, Вы получили достижение в "${this.lists.stable.name}"`);
          this.lists.stable.isSnackBar = false;
          this.lists.stable.value = 100;
          this.lists.stable.class = 'active';
        }else{
          this.lists.stable.value = 100;
        }
        this.lists.stable.count = this.lists.stable.count + 1;
        this.lists.stable.counter = 0;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'nutri-templs';
        dialogConfig.backdropClass = 'nutri-templs-backdrop';
        dialogConfig.data = { name:  this.lists.stable.name , count: this.lists.stable.count, class: 'cl-stable' };
        const dialogRef = this.dialog.open(GreetingWindow, dialogConfig);
      }else{
        //if(this.lists.stable.isSnackBar){
          this.lists.stable.value = ( this.lists.stable.counter / this.lists.stable.account ) * 100;
        //}
      }
    }else{
      this.lists.stable.counter = 0;
      //if(this.lists.stable.isSnackBar){
        this.lists.stable.value = 0;
      this.lists.stable.point = 0;
      //}
    }
  }

  fnInitMaster(finResult: number, points: number): void {
    if(finResult >= this.lists.master.account){
      this.lists.master.count = this.lists.master.count + 1;
      this.lists.master.point = points;
      this.summPoints = this.summPoints + this.lists.master.point;
      if(this.lists.master.isSnackBar){          
          //alert(`Поздравляем, Вы получили достижение в "${this.lists.master.name}"`);
          this.lists.master.isSnackBar = false;
          this.lists.master.value = ( this.lists.master.count / this.lists.champion.account ) * 100; //100;
          this.lists.master.class = 'active';
      }else{
        this.lists.master.value = ( this.lists.master.count / this.lists.champion.account ) * 100; //100;
      }
      const dialogConfig = new MatDialogConfig();
      dialogConfig.panelClass = 'nutri-templs';
      dialogConfig.backdropClass = 'nutri-templs-backdrop';
      dialogConfig.data = { name:  this.lists.master.name, count: this.lists.master.count, class: 'cl-master' };
      const dialogRef = this.dialog.open(GreetingWindow, dialogConfig);
      dialogRef.afterClosed().pipe(
        tap(() => this.runChampion()),
        take(1)
      ).subscribe();    
    }else{
      this.lists.master.value = 0;
    }
  }

  runChampion(){    
    if(this.lists.master.count % this.lists.champion.account === 0){
      this.lists.champion.count = this.lists.champion.count + 1;
      if(this.lists.champion.isSnackBar){
          const dialogConfig = new MatDialogConfig();
          dialogConfig.panelClass = 'nutri-templs';
          dialogConfig.backdropClass = 'nutri-templs-backdrop';
          dialogConfig.data = { name:  this.lists.champion.name, count: this.lists.champion.count, class: 'cl-champion' };
          const dialogRef = this.dialog.open(GreetingWindow, dialogConfig);
          //alert(`Поздравляем, Вы получили достижение в "${this.lists.champion.name}"`);
          this.eventChanpion.next(true);
          this.lists.champion.isSnackBar = false;
          this.lists.champion.value = 100;
          this.lists.champion.class = 'active';
          this.lists.champion.point = this.summPoints;
      }
    }else{
      if(this.lists.champion.isSnackBar){
        this.lists.champion.value = ( this.lists.master.count / this.lists.champion.account ) * 100; 
      }
    }
  }
  
}
